import { useRef } from 'react';
import { isEqual } from '../utils/isEqual';

/**
 * Memoize value by deep-comparison
 *
 * @param value
 * @returns {*}
 */
export function useDeepMemoize(value) {
	const ref = useRef(value);

	if (!isEqual(value, ref.current)) {
		ref.current = value;
	}

	return ref.current;
}
